<template>
  <div class="layui-collapse">
    <slot />
  </div>
</template>

<script>
export default {
  mounted () {
    this.load()
  },
  methods: {
    load () {
      this.layui.element.render('collapse');
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/LayuiCollapse.vue